import { type I18nLocale, t } from '@ardoq/i18n';
import type {
  ViewLegendLabels,
  VisualDiffLegendLabels,
} from '@ardoq/view-legend';

// Translated label set passed to the @ardoq/view-legend package
// (Pattern A / translation-free package). English defaults match the
// package's own defaults so callers in English locales get identical output.

export const getVisualDiffLegendLabels = (
  i18nLocale: I18nLocale
): VisualDiffLegendLabels => ({
  added: t(i18nLocale, 'viewLegend:visualDiff.added', 'added'),
  changed: t(i18nLocale, 'viewLegend:visualDiff.changed', 'changed'),
  removed: t(i18nLocale, 'viewLegend:visualDiff.removed', 'removed'),
  unchanged: t(i18nLocale, 'viewLegend:visualDiff.unchanged', 'unchanged'),
  componentPresentInScenario: t(
    i18nLocale,
    'viewLegend:visualDiff.componentPresentInScenario',
    'Component present in scenario'
  ),
  componentPresentInMainline: t(
    i18nLocale,
    'viewLegend:visualDiff.componentPresentInMainline',
    'Component present in mainline'
  ),
});

export const getViewLegendLabels = (
  i18nLocale: I18nLocale
): ViewLegendLabels => ({
  visualDiff: t(i18nLocale, 'viewLegend:visualDiff.heading', 'Visual Diff'),
  connectedPeople: t(
    i18nLocale,
    'viewLegend:connectedPeople',
    'Connected People'
  ),
  components: t(i18nLocale, 'viewLegend:components', 'Components'),
  references: t(i18nLocale, 'viewLegend:references', 'References'),
  conditionalFormatting: t(
    i18nLocale,
    'viewLegend:conditionalFormatting',
    'Conditional Formatting'
  ),
  formattingComponentsHeading: t(
    i18nLocale,
    'viewLegend:formattingComponentsHeading',
    'Components'
  ),
  formattingReferencesHeading: t(
    i18nLocale,
    'viewLegend:formattingReferencesHeading',
    'References'
  ),
  formattingTagsHeading: t(
    i18nLocale,
    'viewLegend:formattingTagsHeading',
    'Tags'
  ),
  visualDiffLabels: getVisualDiffLegendLabels(i18nLocale),
});
